export default {"src":"/_next/static/media/pathways.a0340b89.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};